import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { UserLabel } from '@/components/ui/user-label'
import { staffUserName, useStaffUsers } from '@/models/user'

interface LeadActionAssigneePickerProps {
  value: string | null
  onChange: (userId: string) => void
}

/** Picks who an Assign run gives each lead to, from the same list as the sidebar's Assigned to. */
export function LeadActionAssigneePicker({ value, onChange }: LeadActionAssigneePickerProps) {
  const { staffUsers } = useStaffUsers()

  return (
    <Select value={value ?? ''} onValueChange={onChange}>
      <SelectTrigger className="w-full" aria-label="Assign to">
        <SelectValue placeholder="Pick who gets the leads" />
      </SelectTrigger>
      <SelectContent>
        {staffUsers.map((user) => (
          <SelectItem key={user.id} value={user.id}>
            <UserLabel name={staffUserName(user)} src={user.avatar} />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
